module.exports = require("core-js-pure/stable/instance/find");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/find.js
// module id = 110
// module chunks = 0 1